import React from 'react'

import InputField     from 'src/components/InputField'
import MoneyField     from 'src/components/MoneyField'
import SandwichField  from 'src/components/SandwichField'

const TippingText = ({ i18n, donation, errors, labelClass, label = i18n.t('tip_label') }) => {
  const currencyFormat = i18n.currency.format.replace('%c', '').trim()
  const currencyFormatParts = currencyFormat.split('%n')

  return (
    <InputField
      type={SandwichField}
      forwardType={MoneyField}
      autoFocus
      id="tip"
      label={label}
      labelClass={labelClass}
      errors={errors}
      prefix={` ${currencyFormatParts[0].replace('%u', donation.currency.symbol || '')} `}
      suffix={` ${currencyFormatParts[1].replace('%u', donation.currency.symbol || '')} `}
      exponent={donation.currency.exponent}
      decimal={i18n.currency.separator}
      wrapperClass="mb-3 d-flex flex-column align-items-start"
      className="form-control money-field"
      value={donation.state.tipText}
      onChange={e => donation.dispatch({ type: 'setTipText', value: e.target.value })}
    />
  )
}

export default TippingText
